<template>
  <div class="home-wrap" :class="themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="fixedBar" ref="fixedBar">
      <div class="index_title">
        <div class="index_title_left">
          <span class="h1">涨价机会</span>
          <span class="hint" v-if="status == 0" @click="handleDy(1)">
            <img src="../assets/images/dy.png" alt="" />
            订阅
          </span>

          <span class="hint" v-else @click="handleDy(0)">
            <img src="../assets/images/dy.png" alt="" />
            已订阅
          </span>
        </div>

        <p class="all" @click="handleClickSeeall">
          查看全部&nbsp;
          <van-icon name="arrow" />
        </p>
      </div>

      <div class="zjjh">
        <!-- <p class="news">
          本月已捕获机会
          <span>{{ cnt }}</span>
          条
        </p> -->

        <ul class="zjjhList" :style="`background:url('${zjjhIndex == 0 && themeStyleVs != 2 ? zjjh0 : zjjhIndex == 1 && themeStyleVs != 2 ? zjjh1 : zjjhIndex == 2 && themeStyleVs != 2 ? zjjh2 : zjjhIndex == 0 && themeStyleVs == 2 ? zjjh_0_black : zjjhIndex == 1 && themeStyleVs == 2 ? zjjh_1_black : zjjhIndex == 2 && themeStyleVs == 2 ? zjjh_2_black : ''}') no-repeat center center / 100% 100%`">
          <div class="tab">
            <h2 v-for="(item, index) in zjjhList" :key="index" @click="zjjhIndex = index" class="van-ellipsis">
              <p class="checked" v-if="zjjhIndex == index"></p>
              {{ item.category }}{{ item.suffix }}
            </h2>
          </div>
          <template v-for="(item, index) in zjjhList">
            <li class="zjjhList_li" :key="index" v-if="zjjhIndex == index">
              <div class="title">
                <span class="tag" :class="item.p1zf > 0 ? 'up' : item.p1zf == 0 ? 'flat' : 'down'">
                  {{ item.tag }}
                </span>
                <span>
                  {{ item.time }}, 指标:{{ item.indexname }}
                  <span>{{ item.p1zf >= 0 ? "上涨" : "下跌" }}</span>
                  <span :class="[judgeColor(Number(item.p1zf))]">{{ item.p1zf }}%</span>
                </span>
              </div>

              <div class="correlation" v-if="item.relatedStock?.length">
                <span class="label2">相关股票</span>
                <!-- 龙虎榜>小市值>创业板 -->
                <span class="correlation_list" v-for="(item2, index2) in item.relatedStock" :key="index2" @click="goToFs(item2.code)" v-show="index2 < 1">
                  <span class="label3" :style="stockInform[item2.code]?.ZhangFu > 0 ? 'color:#EF3939;border:1px solid #EF3939' : stockInform[item2.code]?.ZhangFu < 0 ? 'color:#1EAC4E;border:1px solid #1EAC4E' : 'color:#999;border:1px solid #999'" v-if="RepDataLongHuBang.ShangBangCiShu > 0">龙虎榜</span>
                  <span class="label3" :style="stockInform[item2.code]?.ZhangFu > 0 ? 'color:#EF3939;border:1px solid #EF3939' : stockInform[item2.code]?.ZhangFu < 0 ? 'color:#1EAC4E;border:1px solid #1EAC4E' : 'color:#999;border:1px solid #999'" v-else-if="stockInform[item2.code]?.LiuTongShiZhi < 500000">小市值</span>
                  <span class="label3" :style="stockInform[item2.code]?.ZhangFu > 0 ? 'color:#EF3939;border:1px solid #EF3939' : stockInform[item2.code]?.ZhangFu < 0 ? 'color:#1EAC4E;border:1px solid #1EAC4E' : 'color:#999;border:1px solid #999'" v-else-if="item2.code.indexOf('SZ3') > -1">创业板</span>

                  <span class="code" v-if="isVip3062 || isVip504">
                    {{ item2.name }}
                  </span>
                  <span class="code" v-else>****</span>
                  <span class="zf" :class="[judgeColor(Number(stockInform[item2.code]?.ZhangFu))]">{{ toFixedNum(stockInform[item2.code]?.ZhangFu, 2, "") }}%</span>
                </span>
              </div>

              <div class="importance">
                <div class="importance_left">
                  <span class="label2">热度</span>

                  <div class="star_list">
                    <img src="../assets/images/star2-2.png" alt="" v-for="(star, starIndex) in item.star" :key="starIndex + 'a'" />

                    <img src="../assets/images/star2-1.png" alt="" v-for="(star, starIndex) in 3 - item.star" :key="starIndex + 'b'" />
                  </div>
                </div>

                <span class="importance_right" @click="toDetail(item.factorId)">
                  详细解读
                  <van-icon name="arrow" />
                </span>
              </div>
            </li>
          </template>
        </ul>
      </div>
    </div>

    <div class="index_title">
      <div class="index_title_left">
        <span class="h1">行业追踪</span>
      </div>
    </div>

    <ul class="link-img">
      <li v-for="(item, index) in linkImgList" :key="index" :style="`background:url('${item.bgImg}') no-repeat center center / cover`" @click="toHyDetail(item.linUrl)">
        <div>
          <p class="title">
            {{ results[item.code]?.title || "产业数据大全" }}
          </p>
          <p class="item">
            {{ item.name }}
            <van-icon name="arrow" />
          </p>
        </div>
        <span class="new" v-if="results[item.code]?.date">NEW</span>
      </li>
    </ul>

    <div class="index_title" ref="gnld">
      <div class="index_title_left">
        <span class="h1">概念雷达</span>
      </div>

      <p class="all" v-if="navIndex == 2" @click="viewStatus = !viewStatus">
        <svg v-if="viewStatus" t="1721891001645" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5080" width="11" height="11">
          <path
            d="M332.8 102.4a25.6 25.6 0 0 1 25.6 25.6v204.8a25.6 25.6 0 0 1-25.6 25.6H128a25.6 25.6 0 0 1-25.6-25.6V128a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4H128a128 128 0 0 0-128 128v204.8a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128V128a128 128 0 0 0-128-128zM896 102.4a25.6 25.6 0 0 1 25.6 25.6v384a25.6 25.6 0 0 1-25.6 25.6h-204.8a25.6 25.6 0 0 1-25.6-25.6V128a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4h-204.8a128 128 0 0 0-128 128v384a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128V128a128 128 0 0 0-128-128zM896 819.2a25.6 25.6 0 0 1 25.6 25.6v51.2a25.6 25.6 0 0 1-25.6 25.6h-204.8a25.6 25.6 0 0 1-25.6-25.6v-51.2a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4h-204.8a128 128 0 0 0-128 128v51.2a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128v-51.2a128 128 0 0 0-128-128zM332.8 665.6a25.6 25.6 0 0 1 25.6 25.6v204.8a25.6 25.6 0 0 1-25.6 25.6H128a25.6 25.6 0 0 1-25.6-25.6v-204.8a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4H128a128 128 0 0 0-128 128v204.8a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128v-204.8a128 128 0 0 0-128-128z"
            p-id="5081"
            fill="#4e5969"
          ></path>
        </svg>

        <svg v-else t="1723087368415" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5339" width="11" height="11">
          <path d="M332.8 102.4a25.6 25.6 0 0 1 25.6 25.6v204.8a25.6 25.6 0 0 1-25.6 25.6H128a25.6 25.6 0 0 1-25.6-25.6V128a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4H128a128 128 0 0 0-128 128v204.8a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128V128a128 128 0 0 0-128-128zM332.8 665.6a25.6 25.6 0 0 1 25.6 25.6v204.8a25.6 25.6 0 0 1-25.6 25.6H128a25.6 25.6 0 0 1-25.6-25.6v-204.8a25.6 25.6 0 0 1 25.6-25.6h204.8m0-102.4H128a128 128 0 0 0-128 128v204.8a128 128 0 0 0 128 128h204.8a128 128 0 0 0 128-128v-204.8a128 128 0 0 0-128-128z" p-id="5340" fill="#4e5969"></path>
          <path d="M563.2 85.76m51.2 0l358.4 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-358.4 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z" p-id="5341" fill="#4e5969"></path>
          <path d="M563.2 304.384m51.2 0l358.4 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-358.4 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z" p-id="5342" fill="#4e5969"></path>
          <path d="M563.2 616.96m51.2 0l358.4 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-358.4 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z" p-id="5343" fill="#4e5969"></path>
          <path d="M563.2 835.584m51.2 0l358.4 0q51.2 0 51.2 51.2l0 0q0 51.2-51.2 51.2l-358.4 0q-51.2 0-51.2-51.2l0 0q0-51.2 51.2-51.2Z" p-id="5344" fill="#4e5969"></path>
        </svg>
        &nbsp; 切换视图
      </p>
    </div>

    <div>
      <div class="nav-list">
        <template v-for="(nav, index) in navList">
          <span
            :key="index"
            @click="changeNav(nav.id)"
            v-if="nav.id > 0"
            :class="{
              cur: navIndex == nav.id,
            }"
            :style="nav.hint ? 'margin-right: 0.2rem' : ''"
          >
            {{ nav.name }}
            <i v-if="nav.hint" class="hint">{{ nav.hint }}</i>
          </span>
        </template>
      </div>
      <div class="filter-bar" v-if="navIndex == 1">
        <div class="search">
          <input type="text" placeholder="请输入资讯关键词" v-model.trim="searchTitle" @focus="isHyActive = false" @input="inputSearch" @keydown.enter="changeSearch" />
          <img src="../assets/images/search.png" alt="" @click="changeSearch" v-if="themeStyleVs == 1" />
          <img src="../assets/images/black/search.png" alt="" @click="changeSearch" v-else />
        </div>
        <p class="hySelect" @click="isHyActive = !isHyActive" :class="{ active: isHyActive, cur: swiValue != '行业筛选' }" v-show="navIndex == 1">
          {{ swiValue }}
        </p>
      </div>
      <div class="filter-bar filter-bar2" v-if="navIndex == 5">
        <div class="search search2 win100" @click="goSearchStock">
          <img src="../assets/images/search2.png" alt="" v-if="themeStyleVs == 1" />
          <img src="../assets/images/black/search2.png" alt="" v-else />
          <span>请输入股票</span>
        </div>
      </div>
      <div class="yjtp-title" v-if="navIndex == 5">
        <span v-for="(item, index) in yjtpTitleList" :key="index">
          {{ item }}
        </span>
      </div>

      <div class="pop-hy" v-if="isHyActive" @click="isHyActive = false">
        <div class="pop-con" @click.stop="isHyActive = true">
          <div class="hy-list">
            <div class="item">
              <span v-for="(value, index) in hyData1" :key="value.label" :class="{ cur: index == hyIndex1 }" @click.stop="selectHy(1, index)">
                {{ value.label }}
              </span>
            </div>
            <div class="item">
              <span v-for="(value, index) in hyData2" :key="value.label" :class="{ cur: index == hyIndex2 }" @click.stop="selectHy(2, index)">
                {{ value.label }}
              </span>
            </div>
            <div class="item">
              <span v-for="(value, index) in hyData3" :key="value.label" :class="{ cur: index == hyIndex3 }" @click.stop="selectHy(3, index)">
                {{ value.label }}
              </span>
            </div>
          </div>
          <div class="buttons">
            <span @click.stop="resetHy">重置</span>
            <span @click.stop="sureHy">确认</span>
          </div>
        </div>
      </div>
    </div>

    <div ref="content">
      <!-- 全部 20240705  王臣 -->
      <All v-if="navIndex == 0" />

      <!-- 产业图谱 涨价雷达 机会预警 行业景气 -->

      <!-- 产业图谱 -->
      <Cyltp v-if="navIndex == 2" :themeStyleVs="themeStyleVs" :viewStatus="viewStatus" :handleDataLoadedNum="handleDataLoadedNum" @data-loaded="handleDataLoaded" />

      <!-- 涨价雷达 -->
      <Zjld v-if="navIndex == 6" ref="Zjld" :handleDataLoadedNum="handleDataLoadedNum" @data-loaded="handleDataLoaded" :yunToken="yunToken" />

      <!-- 机会预警 -->
      <Jhyj :jhyjParam="jhyjParam" v-if="navIndex == 1" ref="Jhyj" :handleDataLoadedNum="handleDataLoadedNum" @data-loaded="handleDataLoaded" />

      <!-- 行业景气 20240530  王臣 -->
      <Hyjq v-if="navIndex == 3" :handleDataLoadedNum="handleDataLoadedNum" @data-loaded="handleDataLoaded"></Hyjq>

      <!-- 市场研究 -->
      <div style="height: calc(100vh - 0.85rem); overflow-y: auto" v-if="navIndex == 4">
        <iframe :src="hyyj" frameborder="0" style="width: 100%; height: 100%"></iframe>
      </div>

      <!-- 经营图谱 -->
      <Jytp v-if="navIndex == 5" :handleDataLoadedNum="handleDataLoadedNum" @data-loaded="handleDataLoaded" />
    </div>
    <!-- 如果有3062或者504 并且在安卓里面  任意一个权限就可以查看  如果都没有就展示机会宝购买  banner -->
    <div class="shade_bg" v-if="!isVip3062 && !isVip504">
      <div class="qlyj_banner">
        <p class="banner_jhb">
          <img src="../assets/images/banner_jhb.png" alt="" />
        </p>
        <p class="p1">【产业图谱】100+独家原创图谱,深挖全产业链公司</p>
        <p class="p2">【机会预警】监测产品涨价波动,发现业绩增长潜力</p>
        <button class="banner_btn" @click="handleClickJhb">
          尝鲜价¥
          <span>198</span>
          /季 &gt;&gt;
        </button>
        <p class="p3">同步解锁大智慧PC终端产业图谱，板块列表（31）可快捷查看</p>
      </div>
    </div>
  </div>
</template>

<script>
  import All from "../components/All.vue";
  import Zjld from "../components/Zjld.vue";
  import Jhyj from "../components/Jhyj.vue";
  import Jytp from "../components/Jytp.vue";
  import Cyltp from "../components/Cyltp.vue";
  import Hyjq from "../components/Hyjq.vue"; //行业景气

  import bgimg1 from "../assets/images/qiche.jpg";
  import bgimg2 from "../assets/images/yiyao.jpg";
  import bgimg3 from "../assets/images/dianzi.jpg";
  import bgimg4 from "../assets/images/shipin.jpg";
  import bgimg5 from "../assets/images/jiaotong.jpg";
  import bgimg6 from "../assets/images/jichu.jpg";
  import bgimg7 from "../assets/images/nonglin.jpg";
  import bgimg8 from "../assets/images/youse.jpg";

  import zjjh0 from "../assets/images/zjjh_0.png";
  import zjjh1 from "../assets/images/zjjh_1.png";
  import zjjh2 from "../assets/images/zjjh_2.png";

  import zjjh_0_black from "../assets/images/zjjh_0_black.png";
  import zjjh_1_black from "../assets/images/zjjh_1_black.png";
  import zjjh_2_black from "../assets/images/zjjh_2_black.png";

  import { Toast } from "vant";
  // 将Toast组件封装为全局方法
  window.showToast = function (message) {
    Toast(message);
  };

  window.handleClickDy = (i) => {
    if (i) {
      vueData.status = 1;
    } else {
      vueData.status = 0;
      window.showToast("订阅失败");
    }
  };

  window.handleClickQxDy = (i) => {
    if (i) {
      vueData.status = 0;
      window.showToast("取消成功");
    } else {
      vueData.status = 1;
      window.showToast("取消失败");
    }
  };

  var vueData; // 保存Vue组件的数据

  window.getDyTypeFun = (i) => {
    vueData.status = JSON.parse(window.atob(i)).status;
  };

  // iframe环境下的订阅状态处理函数
  window.handleIframeDyStatus = (data) => {
    if (vueData && data) {
      vueData.status = data.status || 0;
    }
  };

  window.handleIframeDyResult = (data) => {
    if (vueData && data) {
      if (data.success) {
        vueData.status = data.status;
        window.showToast(data.message || (data.status ? "订阅成功" : "取消成功"));
      } else {
        window.showToast(data.message || "操作失败");
      }
    }
  };

  export default {
    components: {
      All, // 全部
      Zjld, //涨价雷达
      Jhyj, // 机会预警
      Jytp, // 企业图谱
      Cyltp,
      Hyjq, //行业景气
    },
    data() {
      return {
        websocket: null,
        viewStatus: true,
        handleDataLoadedNum: null,
        touchStartY1: null,
        touchStartY2: null,
        timeoutId1: null,
        timeoutId2: null,
        zjjhIndex: 0,
        themeStyleVs: 1,
        token: "", // 客户端token
        zjjh0,
        zjjh1,
        zjjh2,
        zjjh_0_black,
        zjjh_1_black,
        zjjh_2_black,
        linkImgList: [
          {
            name: "汽车行业",
            linUrl: window.config.hyLink + "?code=SW280000&DZHSPECIAL=131357",
            bgImg: bgimg1,
            code: 280000,
          },
          {
            name: "医药行业",
            linUrl: window.config.hyLink + "?code=SW370000&DZHSPECIAL=131357",
            bgImg: bgimg2,
            code: 370000,
          },
          {
            name: "电子行业",
            linUrl: window.config.hyLink + "?code=SW270000&DZHSPECIAL=131357",
            bgImg: bgimg3,
            code: 270000,
          },
          {
            name: "食品饮料",
            linUrl: window.config.hyLink + "?code=SW340000&DZHSPECIAL=131357",
            bgImg: bgimg4,
            code: 340000,
          },
          {
            name: "交通运输",
            linUrl: window.config.hyLink + "?code=SW420000&DZHSPECIAL=131357",
            bgImg: bgimg5,
            code: 420000,
          },
          {
            name: "基础化工",
            linUrl: window.config.hyLink + "?code=SW220000&DZHSPECIAL=131357",
            bgImg: bgimg6,
            code: 220000,
          },
          {
            name: "农林牧渔",
            linUrl: window.config.hyLink + "?code=SW110000&DZHSPECIAL=131357",
            bgImg: bgimg7,
            code: 110000,
          },
          {
            name: "有色金属",
            linUrl: window.config.hyLink + "?code=SW240000&DZHSPECIAL=131357",
            bgImg: bgimg8,
            code: 240000,
          },
        ],
        yjtpTitleList: ["股票名称", "股票代码", "框架星级", "研究员讲解"],
        navIndex: 2,
        navList: [
          {
            id: 0,
            name: "全部",
            value: "",
          },
          {
            id: 2,
            name: "产业图谱",
            value: "cytp",
            hint: "NEW",
          },
          {
            id: 6,
            name: "涨价雷达",
            value: "qlyj-yjyggyj",
          },

          {
            id: 1,
            name: "机会预警",
            value: "qlyj-yjyggyj",
          },

          {
            id: 3,
            name: "行业景气",
            value: "hyjq",
            hint: "HOT",
          },
          {
            id: 4,
            name: "市场研究",
            value: "",
          },
          /* {
            id: 5,
            name: "负面舆情",
            value: "qlyj-fmyq", //qlyj-gsds
          }, */
          {
            id: 5,
            name: "经营图谱",
            value: "jytp",
          },
        ],
        searchTitle: "", //搜索文字
        swiValue: "行业筛选",
        swiCode: "", // 申万行业代码
        level: 1, // 行业等级
        key: "", // 上级父行业行业代码
        hyDefault: [
          {
            label: "不限",
            value: "",
          },
        ],
        hyData1: [
          {
            label: "不限",
            value: "",
          },
        ], // 一级行业数据
        hyData2: [
          {
            label: "不限",
            value: "",
          },
        ], // 二级行业数据
        hyData3: [
          {
            label: "不限",
            value: "",
          },
        ], // 三级行业数据
        isHyActive: false,
        hyIndex1: 0,
        hyIndex2: 0,
        hyIndex3: 0,
        isVip3062: true,
        isVip504: true,
        isJytp: false, // 经营图谱page
        jhyjParam: {},
        isFixed: false,
        // searchStockName: '',
        // stockCode: '',
        // isStock: false,
        // stockList: '', // 股票列表
        hyyj: "",
        zjjhList: [],
        cnt: 0,
        status: 0,
        results: {}, // 用于存储每个 hycode 对应的返回数据
        yunToken: "",
        RepDataLongHuBang: {},
        stockInform: {},
        codes: "",
      };
    },
    created() {
      vueData = this.$data; // 保存Vue组件的数据到vueData变量中
      let _self = this;

      window.addEventListener(
        "message",
        function (event) {
          if (event.data.type == "DzhOpenUrl") {
            console.log(event.data);
            _self.toUrl(event.data.url);
          }
          // 处理来自父窗口的订阅状态响应
          else if (event.data.action === 'subscriptionStatusResponse') {
            _self.handleSubscriptionStatusResponse(event.data.data);
          }
          // 处理来自父窗口的订阅操作结果
          else if (event.data.action === 'subscriptionOperationResult') {
            _self.handleSubscriptionOperationResult(event.data.data);
          }
        },
        false
      );

      this.navIndex = this.$route.query.navIndex || 2;

      localStorage.removeItem("token");
      localStorage.removeItem("fmyqVisited");
      localStorage.removeItem("jhyjVisited");
      this.jhyjParam = {
        category: this.findNavById(this.navIndex).value, //资讯分类
        title: "", // 搜索内容
        swiCode: "", // 申万行业代码
      };
    },
    async mounted() {
      await this.getYunToken();

      // 处理订阅状态获取
      this.initSubscriptionStatus();

      let theme = this.$route.query.themeStyleVs || 1;
      if (Array.isArray(theme)) {
        theme = theme[0];
      }

      this.hyyj = window.config.hyyj + "/?token=" + this.$route.query.token + "&themeStyleVs=" + theme;
      this.token = this.$route.query.token;
      this.themeStyleVs = theme;
      this.$store.commit("getToken", this.token);

      this.getZjjhList(); //获取涨价机会
      this.getVip("3062,504");
      if (this.token) {
        this.getHy();
      }

      window.addEventListener("touchstart", this.handleTouchStart);
      window.addEventListener("touchend", this.handleTouchEnd);

      let arr = ["280000", "370000", "270000", "340000", "420000", "220000", "110000", "240000"];

      for (const hycode of arr) {
        const res = await this.updateDt(hycode);
        this.$set(this.results, hycode, res.data); // 使用 this.$set 确保响应式更新
      }
    },
    beforeDestroy() {
      this.websocket.send("/cancel?qid=home");
      window.removeEventListener("touchstart", this.handleTouchStart);
      window.removeEventListener("touchend", this.handleTouchEnd);
      if (this.timeoutId1) {
        clearTimeout(this.timeoutId1);
      }

      if (this.timeoutId2) {
        clearTimeout(this.timeoutId2);
      }
    },
    methods: {
      toFixedNum(value, toFixed, unit) {
        if (value === null || value === undefined || isNaN(Number(value))) {
          return "--"; // 处理 null、undefined 和 NaN 的情况
        }

        if (typeof value === "number" || !isNaN(Number(value))) {
          const parsedValue = typeof value === "number" ? value : parseFloat(value);
          const formattedValue = parsedValue.toFixed(toFixed);
          const paddedValue = formattedValue.padStart(formattedValue.indexOf(".") + 3, "0"); // 保留两位小数

          if (parsedValue !== 0) {
            return paddedValue + unit;
          } else {
            return "0.00" + unit;
          }
        } else {
          return "--";
        }
      },
      // 请求云平台token
      async getYunToken() {
        try {
          let res = await this.$http({
            method: "get",
            url: window.config.api_v3 + "/token/access",
            params: {
              appid: window.config.appid,
              secret_key: window.config.secretKey,
            },
          });
          this.yunToken = res.data.Data.RepDataToken[0].token;
        } catch (error) {
          console.error(error);
        }
      },
      //点击行业跳转
      toHyDetail(url) {
        this.toUrl(url);
      },
      //行业追踪更新信息
      // 需要确保 updateDt 返回一个 Promise，例如：
      updateDt(hycode) {
        return this.$http({
          method: "get",
          url: window.config.hyzz + `/wap/data/news-web/qlyj/${hycode}/updateDt.json`,
        })
          .then((res) => {
            return res; // 返回响应结果
          })
          .catch(() => {
            return "";
          });
      },

      //涨价机会点击查看全部
      handleClickSeeall() {
        this.handleDataLoadedNum = 6;
        this.navIndex = 6;

        if (this.$refs.gnld) {
          this.scrollToElement(this.$refs.gnld);
        }
      },
      //点击详细解读 跳转  行业景气
      toDetail(indexId) {
        // let data = {
        //   curZf: item.p1zf || "",
        //   d7Zf: item.d7zf || "",
        //   d30Zf: item.d30zf || "",
        //   d60Zf: item.d60zf || "",
        //   d90Zf: item.d90zf || "",
        //   ys2curZf: item.ys2czf || "",
        //   indexId: item.factorId || "",
        //   factor: {
        //     indexid: item.factorId || "",
        //     indexname: item.indexname || "",
        //     updateFreqStr: item.updateFreqStr || "",
        //   },
        //   industryName: item.industryName || "",
        //   yptIndustryCode: item.yptIndustryCode || "",
        // };

        // let _this = this;
        // let a = _this.$base64.encode(encodeURIComponent(JSON.stringify(data)));
        // const url = window.config.hyjq_detail;

        // location.href = `${url}/hyjqDetail?DZHSPECIAL=4194305&token=${_this.$route.query.token}&item=${a}`;
        let _this = this;

        const url = `${window.config.hyjq_detail}/hyjqDetail?DZHSPECIAL=4194569&themeStyleVs=${_this.themeStyleVs}&indexId=${indexId}`;

        this.toUrl(url);
      },
      findNavById(id) {
        return this.navList.find((navItem) => navItem.id === id);
      },
      judgeColor(n) {
        if (n == 0) {
          return "gray";
        } else if (n > 0) {
          return "red";
        } else if (n < 0) {
          return "green";
        }
      },
      handleTouchStart(event) {
        // const targetElement = this.$refs.fixedBar;
        const contentTarget = this.$refs.content;

        // if (
        //   event.target === targetElement ||
        //   targetElement.contains(event.target)
        // ) {
        //   if (event.touches.length > 0) {
        //     this.touchStartY1 = event.touches[0].clientY;
        //   }
        // }

        if (event.target === contentTarget || contentTarget.contains(event.target)) {
          if (event.touches.length > 0) {
            this.touchStartY2 = event.touches[0].clientY;
          }
        }
      },
      handleTouchEnd(event) {
        // const targetElement1 = this.$refs.fixedBar;
        const targetElement2 = this.$refs.content;

        const touchEndY = event.changedTouches[0].clientY;
        // const touchDiff1 = touchEndY - this.touchStartY1;
        const touchDiff2 = touchEndY - this.touchStartY2;

        // if (
        //   this.touchStartY1 != null ||
        //   (event.target === targetElement1 &&
        //     targetElement1.contains(event.target))
        // ) {
        //   // 清除之前的定时器
        //   if (this.timeoutId1) {
        //     clearTimeout(this.timeoutId1);
        //   }

        //   // 延迟执行滚动逻辑
        //   this.timeoutId1 = setTimeout(() => {
        //     if (touchDiff1 < 0) {
        //       // 手指往上滑，等待 DOM 更新后执行滚动
        //       console.log("手指往上滑，将概念雷达滚动到浏览器最顶部");
        //       if (this.$refs.gnld) {
        //         this.scrollToElement(this.$refs.gnld);
        //       }
        //     } else if (touchDiff1 > 0) {
        //       // 手指往下滑
        //       console.log("手指往下滑，浏览器滚动到最顶部");
        //       window.scrollTo({ top: 0, behavior: "smooth" });
        //     }

        //     // 重置触摸起始位置
        //     this.touchStartY1 = null;
        //   }, 300); // 延迟300毫秒执行
        // }

        if (this.touchStartY2 != null || (event.target === targetElement2 && targetElement2.contains(event.target))) {
          // 清除之前的定时器
          if (this.timeoutId2) {
            clearTimeout(this.timeoutId2);
          }

          // 延迟执行滚动逻辑
          this.timeoutId2 = setTimeout(() => {
            if (touchDiff2 < 0) {
              // 手指往上滑，等待 DOM 更新后执行滚动
              console.log("手指往上滑，将概念雷达滚动到浏览器最顶部");
              if (this.$refs.gnld) {
                this.scrollToElement(this.$refs.gnld);
              }
            }

            // 重置触摸起始位置
            this.touchStartY2 = null;
          }, 300); // 延迟300毫秒执行
        }
      },
      scrollToElement(element) {
        if (!element) {
          console.error("元素未定义");
          return;
        }
        const rect = element.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      },

      handleClickJhb() {
        let s = this.$route.query.s || 1;
        if (this.isiOS()) {
          this.toUrl(window.config.payIos_url + "?DZHSPECIAL=273&productId=504&token=" + this.token + "&s=" + s);
        } else {
          this.toUrl(window.config.payAz_url + "?DZHSPECIAL=273&productId=504&token=" + this.token + "&s=" + s);
        }
      },
      changeNav(id) {
        // 按钮埋点
        // APP-全链研究 104；APP产业图谱tab 279

        this.handleDataLoadedNum = id;

        var trackObj = {};
        if (this.navList[id].name == "产业图谱") {
          trackObj.button_id = "279";
        }
        // window.sensors.login('wentest181');
        window.sensors.track("web_button_click", trackObj);

        this.navIndex = id;

        // // 获取当前的查询参数
        // const currentQuery = { ...this.$route.query };
        // // 修改特定的参数
        // currentQuery.navIndex = id;
        // // 更新 URL 参数
        // this.$router.push({ query: currentQuery });

        this.jhyjParam.category = this.findNavById(id).value;
        this.jhyjParam.title = "";
        this.jhyjParam.swiCode = "";
        this.searchTitle = "";
        this.swiValue = "行业筛选";
        this.isHyActive = false;
        this.resetHy();

        if (id == 4) {
          this.scrollToElement(this.$refs.gnld);
        }
      },

      handleDataLoaded() {
        // 处理子组件数据加载完成后的逻辑
        console.log("子组件数据已加载完成");
        this.scrollToElement(this.$refs.gnld);
      },

      // 检测是否是iOS设备
      isiOS: function () {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      },

      // 检测是否是Android设备
      isAndroid: function () {
        return /Android/.test(navigator.userAgent);
      },

      // 是否是vip
      getVip(need) {
        let _this = this;
        let needsArray = need.split(","); // 将输入的字符串按逗号分割成数组
        let promises = needsArray.map((needItem) => {
          return _this.$http({
            method: "get",
            url: window.config.vip_server + "/power/chkAllowedInIp",
            params: {
              need: needItem,
              pname: "jhb",
              token: _this.token,
            },
          });
        });

        Promise.all(promises)
          .then((results) => {
            // 第一个结果的处理
            if (results[0].data.err == 0) {
              _this.isVip3062 = results[0].data.data;
            } else {
              _this.isVip3062 = false;
            }

            // 第二个结果的处理
            if (results[1].data.err == 0) {
              _this.isVip504 = results[1].data.data;
            } else {
              _this.isVip504 = false;
            }

            console.log(_this.isVip3062, _this.isVip504, "=-=-=-=-=");
          })
          .catch((error) => {
            // 处理请求中的错误
            console.error("Error checking VIP status:", error);
            _this.isVip3062 = false;
            _this.isVip504 = false;
          });
      },
      // 获取申万行业
      getHy() {
        var postParam = {
          qid: new Date().getTime(),
          param: {
            level: this.level,
            key: this.key,
          },
        };
        this.$http({
          method: "post",
          url: window.config.research_server + "/research-framework-server/swi/industry/selector",
          data: postParam,
          headers: {
            token: this.token,
          },
        }).then((res) => {
          if (res.data.data.length > 0) {
            this["hyData" + this.level] = this.hyDefault.concat(res.data.data);
          }
        });
      },
      // 选择行业
      selectHy(level, i) {
        this["hyIndex" + level] = i;
        if (level == 1) {
          if (i !== 0) {
            this.level = level + 1;
            this.key = this.hyData1[i].value;
            this.getHy();
            this.hyData3 = this.hyDefault;
            this.hyIndex2 = 0;
            this.hyIndex3 = 0;
          }
        } else if (level == 2) {
          if (i !== 0) {
            this.key = this.hyData2[i].value;
            this.level = level + 1;
            this.getHy();
            this.hyIndex3 = 0;
          }
        }
      },
      // 重置行业
      resetHy() {
        this.hyIndex1 = 0;
        this.hyIndex2 = 0;
        this.hyIndex3 = 0;
      },
      // 确认行业
      sureHy() {
        var value = this.hyIndex3 ? this.hyData3[this.hyIndex3].label : this.hyIndex2 ? this.hyData2[this.hyIndex2].label : this.hyIndex1 ? this.hyData1[this.hyIndex1].label : "";
        var code = this.hyIndex3 ? this.hyData3[this.hyIndex3].value : this.hyIndex2 ? this.hyData2[this.hyIndex2].value : this.hyIndex1 ? this.hyData1[this.hyIndex1].value : "";
        this.swiValue = value ? value : "行业筛选";
        this.jhyjParam.swiCode = code;
        this.isHyActive = false;
      },
      // 搜索title
      changeSearch() {
        this.jhyjParam.title = this.searchTitle;
      },
      // title为空
      inputSearch() {
        if (this.searchTitle == "") {
          this.jhyjParam.title = "";
        }
      },
      goSearchStock() {
        // this.$router.push('/search')
        this.toUrl(location.origin + location.pathname + "search?DZHSPECIAL=1");
      },

      goVip() {
        this.toUrl(`${window.config.vip_link}/default/index?channel=quanlianyujing&dzhadid=0701&DZHSPECIAL=285`);
      },

      //获取涨价机会
      getZjjhList: function () {
        let _this = this;
        _this
          .$http({
            method: "post",
            url: window.config.api_v1 + "/research-industry-sdk/industry-prosperity/zjjh",
            data: {
              qid: new Date().getTime(),
            },
            headers: {
              token: "ALA*VWKsCZh9Y5HlT2O*dF28an3q4ak9ODXTdiSasFw.2055304686", //这个token有效期10年  2035-02-17 13:58:06到期
            },
          })
          .then(function (res) {
            _this.zjjhList = res.data.data.data;
            _this.cnt = res.data.data.cnt;

            const codes = _this.zjjhList.reduce((accumulator, item) => {
              if (item.relatedStock) {
                item.relatedStock.forEach((stock) => {
                  accumulator.push(stock.code);
                });
              }
              return accumulator;
            }, []);

            _this.codes = codes.toString();
            _this.getLhbData(codes.toString());
            _this.getStocksZf(codes.toString());
          })
          .catch(function () {});
      },

      // 获取龙虎榜数据
      getLhbData: function (code) {
        var _this = this;
        var obj = {
          obj: code,
          field: "ShangBangCiShu,Obj",
          token: _this.yunToken,
        };
        _this
          .$http({
            headers: {
              "Content-Type": "text/plain",
            },
            method: "get",
            url: window.config.yunurl + "/billboard",
            params: obj,
          })
          .then(function (res) {
            let d = res.data.Data.RepDataLongHuBang;
            if (res.data.Err === 0 && d) {
              // 使用 reduce 方法将每一项转换成键值对
              _this.RepDataLongHuBang = d.reduce((accumulator, current) => {
                const key = current.Obj; // 获取键名
                accumulator[key] = current; // 使用原对象作为值
                return accumulator;
              }, {});
            }
          });
      },

      // 请求实时行情数据
      getStocksZf: function (code) {
        var _this = this;
        if (!_this.websocket) {
          _this.websocket = new WebSocket(window.config.yunwsurl + "?token=" + _this.yunToken);
          _this.websocket.onopen = function () {
            _this.websocketSend(code);
          };
        }
        // else {
        //   _this.websocket.send("/cancel?qid=home");
        //   _this.websocketSend(code);
        // }
        _this.websocket.onmessage = function (evt) {
          var fr = new FileReader();
          fr.readAsText(evt.data);
          fr.onload = function () {
            var result = JSON.parse(fr.result);
            var dynaList = result.Data.RepDataStkData;

            // 使用 reduce 方法将每一项转换成键值对
            _this.stockInform = {
              ..._this.stockInform, // 保留旧数据
              ...dynaList.reduce((accumulator, current) => {
                const key = current.Obj; // 获取键名
                accumulator[key] = current; // 使用原对象作为值
                return accumulator;
              }, {}),
            };
          };
        };
      },

      websocketSend: function (code) {
        var url = "/quote/stkdata?obj=" + code + "&field=ZhongWenJianCheng,ZuiXinJia,ZhangFu,LiuTongShiZhi,ShiYingLvPPE&qid=home";
        this.websocket.send(url);
      },

      //跳转原生分时
      goToFs: function (stockCode) {
        let newCode = stockCode.replace("B$", "BI");
        if (window.navigator.userAgent.indexOf("dzhapp") !== -1 || typeof window.DzhAppJs != "undefined") {
          this.toUrl(`dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`);
        } else {
          let d = `dzh_browser_url&goto=0&type=2970&code=${newCode}&kind=1`;
          let url = encodeURIComponent(d);
          this.toUrl(`https://dzhopenapp.gw.com.cn/openapp/download.html?info=${url}`);
        }
      },

      //初始化订阅状态
      initSubscriptionStatus() {
        // 检查是否在iframe环境中
        if (window.parent !== window) {
          // iframe环境：向父窗口请求订阅状态
          this.requestSubscriptionStatusFromParent();
        } else if (window.DzhAppJs) {
          // 非iframe环境：直接调用原生方法
          this.getDyType();
        } else {
          // 无原生环境：设置默认状态
          this.status = 0;
        }
      },

      //向父窗口请求订阅状态
       requestSubscriptionStatusFromParent() {
         window.parent.postMessage({
           action: 'getSubscriptionStatus',
           data: {
             subMsgType: 1
           }
         }, '*');
       },

       //处理来自父窗口的订阅状态响应
       handleSubscriptionStatusResponse(data) {
         if (data && typeof data.status !== 'undefined') {
           this.status = data.status;
         }
       },

       //处理来自父窗口的订阅操作结果
       handleSubscriptionOperationResult(data) {
         if (data) {
           if (data.success) {
             this.status = data.status;
             window.showToast(data.message || (data.status ? "订阅成功" : "取消成功"));
           } else {
             window.showToast(data.message || "操作失败");
           }
         }
       },

      //查询订阅状态
      getDyType() {
        window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          "getMsgSubscribeStatus",
          JSON.stringify({
            subMsgType: 1,
          }),
          "getDyTypeFun"
        );
      },
      //点击订阅
      handleDy(type) {
        // 检查是否在iframe环境中
        if (window.parent !== window) {
          // iframe环境：向父窗口发送订阅操作请求
          this.handleSubscriptionInIframe(type);
        } else if (window.DzhAppJs) {
          // 非iframe环境：直接调用原生方法
          this.handleSubscriptionNative(type);
        } else {
          // 无原生环境：跳转到下载页面
          var d = "dzh_browser_url&goto=0&screen=221&id=1112";
          var url = encodeURIComponent(d);
          this.toUrl("https://dzhopenapp.gw.com.cn/openapp/download.html?info=" + url);
        }
      },

      //iframe环境下的订阅操作
      handleSubscriptionInIframe(type) {
        if (type) {
          // 订阅操作
          window.parent.postMessage({
            action: 'updateSubscriptionStatus',
            data: {
              subMsgType: 1,
              status: type,
              operation: 'subscribe'
            }
          }, '*');
        } else {
          // 取消订阅操作
          this.$dialog
            .confirm({
              title: "提示",
              message: "是否取消订阅?",
            })
            .then(() => {
              window.parent.postMessage({
                action: 'updateSubscriptionStatus',
                data: {
                  subMsgType: 1,
                  status: type,
                  operation: 'unsubscribe'
                }
              }, '*');
            })
            .catch(() => {
              // on cancel
            });
        }
      },

      //原生环境下的订阅操作
      handleSubscriptionNative(type) {
        if (type) {
          window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
            "updateMsgSubscribeStatus",
            JSON.stringify({
              subMsgType: 1,
              status: type,
            }),
            "handleClickDy"
          );
        } else {
          this.$dialog
            .confirm({
              title: "提示",
              message: "是否取消订阅?",
            })
            .then(() => {
              window.DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
                "updateMsgSubscribeStatus",
                JSON.stringify({
                  subMsgType: 1,
                  status: type,
                }),
                "handleClickQxDy"
              );
            })
            .catch(() => {
              // on cancel
            });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .home-wrap {
    .fixedBar {
      background: #fff;
    }
  }
  .fixed {
    position: fixed;
    left: 0;
    top: 0rem;
    right: 0;
    background: #fff;
    z-index: 1;
  }
  .link-img {
    padding: 0.12rem 0.16rem 0.08rem;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    overflow-x: auto;
    li {
      flex-shrink: 0;
      min-width: 0.76rem;
      height: 0.6rem;
      margin-right: 0.08rem;
      background-size: cover;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      padding: 0 0.1rem;
    }
    .title {
      color: #fff;
      font-size: 0.14rem;
      font-weight: 600;
    }
    .item {
      color: #fff;
      font-size: 0.12rem;
    }
    .new {
      display: block;
      position: absolute;
      top: -0.12rem;
      right: 0;
      border-radius: 8px 8px 0 8px;
      background: #f14957;
      width: 0.28rem;
      font-size: 0.09rem;
      color: #fff;
      padding: 2px 0px;
      text-align: center;
      z-index: 3;
    }
  }

  .index_title {
    padding: 0.17rem 0.16rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .index_title_left {
      display: flex;
      align-items: center;
      .h1 {
        font-family: Alimama ShuHeiTi;
        font-weight: 700;
        color: #1d2129;
        font-size: 16px;
        position: relative;
        &:before {
          content: "";
          position: absolute;
          width: 6px;
          height: 0.18rem;
          background: linear-gradient(189.46deg, #2f94f4 -47.3%, #1c65f7 52.7%);
          border-radius: 5px;
          top: 0.02rem;
          left: -0.19rem;
        }
      }

      .hint {
        background: #f1f7ff;
        border-radius: 10px;
        color: #286df7;
        font-size: 0.12rem;
        padding: 0.02rem 0.08rem;
        display: flex;
        align-items: center;
        margin-left: 0.2rem;
        img {
          width: 0.13rem;
          height: 0.13rem;
          margin-right: 0.02rem;
        }
      }
    }

    .all {
      display: flex;
      align-items: center;
      background: #f5f6f9;
      border-radius: 10px;
      font-weight: 500;
      color: #4e5969;
      font-size: 0.11rem;
      padding: 0.03rem 0.09rem;
    }
  }

  .zjjh {
    .news {
      color: #999999;
      font-size: 0.12rem;
      margin-top: 0.08rem;
      padding: 0 0.16rem;
    }
    .zjjhList {
      height: 2.4rem;
      margin-top: 0.15rem;
      padding: 0.24rem 6% 0.12rem;
      .tab {
        display: flex;
        align-items: center;
        h2 {
          font-weight: 700;
          color: #1d2129;
          font-size: 0.15rem;
          position: relative;
          width: 33.33%;
          text-align: center;
          padding: 0 0.05rem;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            padding-right: 0;
          }
          .checked {
            position: absolute;
            width: 0.16rem;
            height: 3px;
            background: #1d2129;
            border-radius: 4px;
            left: 45%;
            top: 0.3rem;
          }
        }
      }
      .zjjhList_li {
        width: 100%;
        height: 100%;
        padding: 0.22rem 0 0.32rem;
        .title {
          color: #1d2129;
          font-size: 0.14rem;
          span {
            font-weight: 600;
          }
          .label {
            width: 0.69rem;
            height: 0.26rem;
            vertical-align: middle;
          }
          .tag {
            font-style: oblique;
            display: inline-block;
            width: 0.71rem;
            height: 0.26rem;
            line-height: 0.24rem;
            text-align: center;
            font-size: 0.13rem;
            color: #fff;
          }
          .up {
            background: url("../assets/images/up.png") no-repeat;
            background-size: 100% 100%;
          }
          .down {
            background: url("../assets/images/down.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        .correlation {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-top: 0.1rem;
          .label2 {
            color: #949da8;
            font-size: 0.12rem;
            flex-shrink: 0;
            width: 0.54rem;
          }

          .correlation_list {
            background: #f7f7fc;
            border-radius: 6px;
            display: flex;
            align-items: center;
            padding: 0.02rem 0.08rem;
            margin-left: 0.1rem;
            .label3 {
              font-size: 0.1rem;
              border: 1px solid #222222;
              border-radius: 2px;
              padding: 0 0.03rem;
              margin-right: 0.05rem;
            }
            .code {
              margin-right: 0.05rem;
              color: #222222;
              font-size: 0.12rem;
            }
            .zf {
              font-weight: 500;
              font-size: 0.12rem;
            }
          }
        }

        .importance {
          margin-top: 0.13rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .importance_left {
            display: flex;
            align-items: center;
            .label2 {
              color: #949da8;
              font-size: 0.12rem;
              flex-shrink: 0;
              width: 0.54rem;
            }
            .star_list {
              margin-left: 0.1rem;
              display: flex;
              align-items: center;
              img {
                width: 0.22rem;
                height: 0.22rem;
              }
            }
          }
          .importance_right {
            display: flex;
            align-items: center;
            color: #286df7;
            font-size: 0.14rem;
          }
        }
      }
    }
  }

  .nav-list {
    padding: 0.16rem 0.16rem 0.04rem;
    display: flex;
    margin-bottom: 0.04rem;
    overflow-x: auto;
    border-bottom: 0.5px solid #e5e5e5;
    span {
      font-size: 0.14rem;
      color: #555;
      text-align: center;
      position: relative;
      flex-shrink: 0;
      @include center-flex;
      + span {
        margin-left: 0.2rem;
      }
      &.cur {
        font-size: 0.16rem;
        color: #222;
        font-weight: bold;
        &:after {
          content: "";
          display: block;
          width: 0.2rem;
          height: 3px;
          background: #222;
          border-radius: 3px;
          position: absolute;
          left: 50%;
          margin-left: -0.1rem;
          bottom: -0.04rem;
        }
      }
      .hint {
        display: block;
        position: absolute;
        top: 0rem;
        right: -0.3rem;
        border-radius: 8px 8px 8px 0px;
        background: #f14957;
        width: 0.28rem;
        font-size: 0.09rem;
        color: #fff;
        padding: 2px 0px;
        text-align: center;
      }
    }
  }
  .filter-bar {
    position: relative;
    padding: 0.08rem 0.16rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search {
      background: #f6f6f6;
      border-radius: 0.2rem;
      width: 1.98rem;
      height: 0.25rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 0.12rem;
      flex: none;
      &.win100 {
        width: 100%;
      }
      input {
        background: #f6f6f6;
        height: 0.17rem;
        width: 85%;
        color: #222;
        font-size: 0.12rem;
        &::placeholder {
          font-size: 0.12rem;
          color: #999;
        }
      }
      img {
        width: 0.13rem;
        flex: none;
      }
    }
    .search2 {
      height: 0.32rem;
      span {
        flex: 1;
        margin-left: 0.1rem;
        text-align: left;
        font-size: 0.14rem;
        color: #999;
      }
    }
    .hySelect {
      font-size: 0.12rem;
      color: #555;
      position: relative;
      flex: 1;
      @include text-overflow;
      padding-right: 0.18rem;
      text-align: right;
      margin-left: 0.2rem;
      &:after {
        @include arrow(5px, #999, 1px, 135deg);
        position: absolute;
        right: 0.06rem;
        top: 0.04rem;
      }
      &.cur {
        color: rgba(40, 109, 247, 1);
        &:after {
          @include arrow(5px, rgba(40, 109, 247, 1), 1px, 135deg);
          top: 0.04rem;
        }
      }
      &.active {
        color: rgba(40, 109, 247, 1);
        &:after {
          @include arrow(5px, rgba(40, 109, 247, 1), 1px, -45deg);
          top: 0.08rem;
        }
      }
    }
    .stockList {
      position: absolute;
      left: 0;
      right: 0;
      top: 0.4rem;
      background: #fff;
      padding: 0 0.16rem;
      li {
        height: 0.48rem;
        line-height: 0.48rem;
        position: relative;
        padding-left: 0.06rem;
        font-size: 0.14rem;
        color: #222;
        &:before {
          @include border(bottom, #e5e5e5);
        }
        em {
          margin-left: 0.06rem;
        }
      }
    }
  }
  .filter-bar2 {
    padding-bottom: 0.12rem;
  }
  .pop-hy {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 10;
    .pop-con {
      position: absolute;
      left: 0;
      right: 0;
      top: 0rem;
      background: #fff;
    }
    .hy-list {
      height: 3.92rem;
      display: flex;
      .item {
        width: 30%;
        flex: none;
        height: 100%;
        overflow-y: auto;
        span {
          height: 0.56rem;
          padding-left: 0.16rem;
          line-height: 0.56rem;
          display: block;
          font-size: 0.14rem;
          color: #555;
          &.cur {
            background: #fff;
            color: rgba(40, 109, 247, 1);
          }
        }
        &:nth-child(3) {
          flex: 1;
          span {
            padding-right: 0.2rem;
            @include text-overflow();
          }
        }
        &:nth-child(1) {
          background: #f3f3f3;
          span {
            &.cur {
              position: relative;
              &:before {
                content: "";
                display: inline-block;
                background: #286df7;
                width: 0.03rem;
                height: 0.14rem;
                @include center-box(y);
                left: 0;
              }
            }
          }
        }
      }
    }
    .buttons {
      display: flex;
      justify-content: flex-end;
      padding: 0.12rem;
      position: relative;
      &:before {
        @include border(top, #e5e5e5);
      }
      span {
        width: 0.4rem;
        text-align: center;
        line-height: 1;
        padding: 0.06rem 0;
        font-size: 0.12rem;
        color: #555;
        + span {
          margin-left: 0.08rem;
          border-radius: 3px;
          background: #286df7;
          color: #fff;
        }
      }
    }
  }
  .yjtp-title {
    height: 0.32rem;
    background: #fafafa;
    font-size: 0.12rem;
    color: #999;
    display: flex;
    padding: 0 0.16rem;
    align-items: center;
    margin: 0 0.08rem;
    span {
      width: 25%;
      text-align: center;
      &:nth-child(1) {
        text-align: left;
        width: 24%;
      }
      &:nth-child(3) {
        padding-left: 0.1rem;
      }
      &:nth-child(2) {
        flex: 1;
      }
    }
  }
  .blackTheme {
    .index_title_left {
      .h1 {
        color: #e4e9fe;
      }
    }
    .fixed {
      background: #171922;
    }
    .nav-list {
      border-bottom: 1px solid #000000;
    }
    .nav-list span {
      color: #aab9d1;
      &.cur {
        color: #e4e9fe;
        &:after {
          background: #e4e9fe;
        }
      }
      &.new {
        i {
          background: #e64452;
        }
      }
    }
    .filter-bar {
      &:before {
        background: #1e212a;
      }
      .search {
        background: #252732;
        input {
          background: #252732;
          color: #e4e9fe;
          &::placeholder {
            color: #6b7687;
          }
        }
      }
      .search2 {
        span {
          color: #6b7687;
        }
      }
      .hySelect {
        color: #aab9d1;
        &.cur {
          color: #3b85fe;
          &:after {
            @include arrow(5px, #3b85fe, 1px, 135deg);
          }
        }
        &.active {
          color: #3b85fe;
          &:after {
            @include arrow(5px, #3b85fe, 1px, -45deg);
          }
        }
      }
    }
    .pop-hy {
      background: rgba(0, 0, 0, 0.5);
      .pop-con {
        background: #171922;
      }
      .hy-list {
        .item {
          span {
            color: #aab9d1;
            &.cur {
              background: #171922;
              color: #3b85fe;
            }
          }
          &:nth-child(1) {
            background: #21232e;
            span {
              &.cur {
                &:before {
                  background: #3b85fe;
                }
              }
            }
          }
        }
      }
      .buttons {
        &:before {
          @include border(top, #0c0f13);
        }
        span {
          color: #aab9d1;
          + span {
            background: #3b85fe;
            color: rgba(255, 255, 255, 0.9);
          }
        }
      }
    }
    .yjtp-title {
      background: #1b1d29;
      color: #6b7687;
    }
  }

  .shade_bg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.7);

    .qlyj_banner {
      width: 100%;
      height: 2.2rem;
      position: absolute;
      bottom: 0;
      z-index: 100;
      text-align: center;
      border-radius: 0.3rem 0.3rem 0 0;
      overflow: hidden;
      background: url("../assets/images/qlyj_banner.jpg");
      background-size: cover;
      padding: 0.13rem 0.3rem;
      .banner_jhb {
        width: 1.2rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .p1,
      .p2 {
        font-weight: 700;
        color: #ffffff;
        font-size: 0.14rem;
        margin-top: 0.08rem;
        text-align: left;
      }
      .banner_btn {
        display: flex;
        align-items: baseline;
        justify-content: center;
        margin-top: 0.08rem;
        width: 100%;
        height: 0.46rem;
        background: linear-gradient(95.1deg, #ffc37c -0.46%, #fff1d5 100%);
        border-radius: 60px;
        box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25) inset, 0px 1px 0px #f3c998 inset;
        color: #c72d25;
        font-size: 0.16rem;
        font-weight: 600;
        span {
          font-weight: 700;
          font-size: 0.28rem;
          margin: 0 0.05rem;
        }
      }
      .p3 {
        color: #ffffff;
        font-size: 0.12rem;
        margin-top: 0.08rem;
      }
    }
  }

  .black_theme {
    .fixedBar {
      background: #171922;
    }

    .index_title {
      .index_title_left {
        .hint {
          background: #272935;
          color: #286df7;
        }
      }
      .all {
        background: #272935;
        color: #aab9d1;
      }
    }
    .zjjh {
      .news {
        color: #6b7687;
      }
      .zjjhList {
        .tab {
          h2 {
            color: #e4e9fe;
            .checked {
              background: #e4e9fe;
            }
          }
        }
      }
      .zjjhList_li {
        .title {
          color: #e4e9fe;
        }
        .correlation {
          .correlation_list {
            background: #272935;
            color: #e4e9fe;
            .code {
              color: #e4e9fe;
            }
          }
        }
        .label2 {
          color: #6b7687;
        }
        .importance {
          .importance_right {
            color: #286df7;
          }
        }
      }
    }
  }
</style>
